import SlickForScreenshots from "./SlickForSceenshots";
const SingleColumnData = ({item})  => {
    let content = null;

    // Switch statement outside JSX to handle content based on item.cc_box_content_alignment
    switch (item.cc_box_content_alignment) {
        case 'bottom':
            content = (
                <div className="process-panels-container tram-hts-container-one-col">
                    <div className="process-panel tram-hts-panel">
                        <h2 className="process-name tram-hts-heading">{item.cc_box_content_title}</h2>
                        <div className="tram-hts-image-section tram-hts-multiple-images">
                            {Array.isArray(item.imageUrl) && item.imageUrl.slice(0, 5).map((img, i) => (
                                <img key={i} src={img} alt="" />
                            ))}
                        </div>
                        {item.imageUrl.length > 1? (
                            <div className="tram-hts-image-slider tram-hts-image-slider-section">
                            <div className="container">
                            <SlickForScreenshots screenshotContent={item.imageUrl} dataSettings={null} />
                            </div>
                        </div>
                        ):(
                            <div className="tram-hts-image-slider tram-hts-image-section">
                            <img src={item.imageUrl}  />
                        </div> 
                        )}
                        
                        <p className="process-desc tram-hts-one-col-content">{item.cc_box_content_content}</p>
                    </div>
                </div>
            );
            break;
            case 'right':
            content = (
                <div className="process-panels-container tram-hts-container-one-col">
                    <div className="process-panel tram-hts-panel-horizontal">
                        
                        <div className="tram-half-width">
                        {item.imageUrl.length > 2?(
                            <div className="tram-hts-image-slider-section">
                            <div className="container">
                                <SlickForScreenshots screenshotContent={item.imageUrl} dataSettings={'left'} />
                                </div>
                            </div>
                        ):(
                            <div className="tram-hts-image-section tram-hts-multiple-images">
                                {Array.isArray(item.imageUrl) && item.imageUrl.slice(0, 2).map((img, i) => (
                                    <img key={i} src={img} alt="" />
                                ))}
                            </div>
                         )}
                            
                        </div>
                        <div className="tram-half-width tram-margin-auto">
                            <h2 className="process-name tram-hts-heading">{item.cc_box_content_title}</h2>
                            <p className="process-desc tram-hts-one-col-content tram-hts-one-col-content-horizontal">
                                {item.cc_box_content_content}
                            </p>
                        </div>
                    </div>
                    <div className="process-panel tram-hts-panel-vertical">
                        <h2 className="process-name tram-hts-heading">{item.cc_box_content_title}</h2>
                        {item.imageUrl.length > 1? (
                            <div className="tram-hts-image-slider tram-hts-image-slider-section">
                        <div className="container">
                            <SlickForScreenshots screenshotContent={item.imageUrl} dataSettings={null} />
                            </div>
                        </div>
                        ):(
                            <div className="tram-hts-image-slider tram-hts-image-section">
                                <img src={item.imageUrl}  />
                            </div> 
                        )}
                        
                        <p className="process-desc tram-hts-one-col-content">{item.cc_box_content_content}</p>
                    </div>
                </div>
            );
            break;
        case 'left':
            content = (
                <div className="process-panels-container tram-hts-container-one-col">
                    <div className="process-panel tram-hts-panel-horizontal">
                        <div className="tram-half-width tram-margin-auto">
                            <h2 className="process-name tram-hts-heading">{item.cc_box_content_title}</h2>
                            <p className="process-desc tram-hts-one-col-content tram-hts-one-col-content-horizontal">
                                {item.cc_box_content_content}
                            </p>
                        </div>
                        <div className="tram-half-width">
                        {item.imageUrl.length > 2?(
                            <div className="tram-hts-image-slider-section">
                            <div className="container">
                                <SlickForScreenshots screenshotContent={item.imageUrl} dataSettings={'left'} />
                                </div>
                            </div>
                        ):(
                            <div className="tram-hts-image-section tram-hts-multiple-images">
                                {Array.isArray(item.imageUrl) && item.imageUrl.slice(0, 2).map((img, i) => (
                                    <img key={i} src={img} alt="" />
                                ))}
                            </div>
                         )}
                            
                        </div>
                    </div>
                    <div className="process-panel tram-hts-panel-vertical">
                        <h2 className="process-name tram-hts-heading">{item.cc_box_content_title}</h2>
                        {item.imageUrl.length > 1? (
                            <div className="tram-hts-image-slider tram-hts-image-slider-section">
                        <div className="container">
                            <SlickForScreenshots screenshotContent={item.imageUrl} dataSettings={null} />
                            </div>
                        </div>
                        ):(
                            <div className="tram-hts-image-slider tram-hts-image-section">
                                <img src={item.imageUrl}  />
                            </div> 
                        )}
                        
                        <p className="process-desc tram-hts-one-col-content">{item.cc_box_content_content}</p>
                    </div>
                </div>
            );
            break;
        default:
            content = null;
            break;
    }

    return(
        <>
          {content}
        
        </>
    );
}

export default SingleColumnData;